// src/firebaseConfig.js
import { initializeApp } from "firebase/app";

// Import Firestore
import { getFirestore } from "firebase/firestore";

// Import Storage (already used by Gallery)
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyBPHXPNOA2OI1ni4K7dZJUrU_6ePocUi0E",
    authDomain: "bakayise-website-builder.firebaseapp.com",
    projectId: "bakayise-website-builder",
    storageBucket: "bakayise-website-builder.firebasestorage.app",
    messagingSenderId: "452498662302",
    appId: "1:452498662302:web:0191b1a90c20265dbfac8f",
    measurementId: "G-6SM6TE1GHY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize database and storage
const db = getFirestore(app);      // ✅ Firestore
const storage = getStorage(app);   // ✅ Storage

// Export for use i components Storage
export {db, storage};
